<div class="tab-list">
	<div *ngFor="let layer of displayedListFix; let idx = index;" 
		class="layer-tab-item" 
		[ngClass]="{'selected-tab-item': layer===selectedLayer, 'disabled-tab-item': disabled}" 
		(click)="onClickTab(layer)">
		<div class="tab-label">{{layer.category ? layer.category.nameShort : ''}}</div>
		<app-layer-state-icon [layerStateName]="layer.state.name"></app-layer-state-icon>
	</div>
	<div *ngIf="displayedOther" 
		class="layer-tab-item" 
		[ngClass]="{'selected-tab-item': displayedOther===selectedLayer, 'disabled-tab-item': disabled}" 
		(click)="onClickTab(displayedOther)">
		<div class="tab-label">{{displayedOther.category ? displayedOther.category.nameShort : ''}}</div>
		<app-layer-state-icon [layerStateName]="displayedOther.state.name"></app-layer-state-icon>
		<mat-select [(ngModel)]="displayedOther" (ngModelChange)="onSelectOther()" (click)="onClickSelectOther()">
			<mat-option *ngFor="let other of displayedListOther" [value]="other">
				<div class="option-wrap">
					<div class="tab-label">{{other.category ? other.category.nameShort : ''}}</div>
					<app-layer-state-icon [layerStateName]="other.state.name"></app-layer-state-icon>
				</div>
			</mat-option>
		</mat-select>
		<!-- <div class="tab-label">{{displayedOther.category ? displayedOther.category.nameShort : ''}}</div>
		<app-layer-state-icon [layerStateName]="displayedOther.state.name"></app-layer-state-icon>
		<div *ngIf="displayedListOther.length > 1" class="fake-select" (click)="onToggleOtherDropdown()">
			<select></select>
		</div>

		<div *ngIf="showDropdown" class="other-list">
			<div *ngFor="let other of displayedListOther" (click)="selectOther(other)">
				<div class="tab-label">{{other.category ? other.category.nameShort : ''}}</div>
				<app-layer-state-icon [layerStateName]="other.state.name"></app-layer-state-icon>
			</div>
		</div> -->
	</div>
</div>